import React from 'react'
import "./css/common.css"

export default function NotebookGenerationTab(props) {
        return (
                <div className="main_tab scrollbar_property">
                        NOTEBOOK Generation
                        <br></br>
                        {props.selected_dataset}
                </div>
        )
}
